import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {LogsContext} from "../../logsContext";
import {WMSOmniScanReturnType} from "../../../../../utils/WMSOmniScanReturnType";
import WmsItemItem from "./component/WmsItemItem";
import ShipmentItem from "./component/ShipmentItem";
import ContainerItem from "./component/ContainerItem";

function ItemList() {
    const {itemType, itemList} = useContext(LogsContext);

    return (
        <>
            {itemList.map((item) => (
                <>
                    {WMSOmniScanReturnType.ITEM === itemType.current && 0 < itemList.length  && (
                        <WmsItemItem wmsItem={item}/>
                    )}

                    {WMSOmniScanReturnType.SHIPMENT === itemType.current && 0 < itemList.length  && (
                        <ShipmentItem shipment={item}/>
                    )}

                    {/*This one will likely never be used as containers are identified by their barcode*/}
                    {WMSOmniScanReturnType.CONTAINER === itemType.current && 0 < itemList.length  && (
                        <ContainerItem container={item}/>
                    )}
                </>
            ))}
        </>
    );
}

export default ItemList;